import { apiConstants } from './shared/config';

const routes = [
    {
        path: `/${apiConstants.code}/home/:ninventario?`,
        name: `${apiConstants.code}.home`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "pim-home" */ './views/Home.vue'),
        meta: {
            title: 'Home',
            auth: {
                roles: ['PIM_00001'],
                redirect: {name: 'portal.login'}, forbiddenRedirect: '/portal/acesso-negado'
            },
        },
    },
];

export default routes;